export default __webpack_public_path__ + "static/banner-the-reality-of-work-and-travel-lisbon-eebdd6b62e3ce2f42f46a4a9d0654b03.jpg";